<template>
  <div class="mt10 container" v-loading="isLoading">
    <div class="myMain">
      <div class="relative">
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          class="containers mb10"
        >
          <el-breadcrumb-item>确认订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="BGwhite pad24 radius8 order-top">
        <h2>确认订单信息</h2>
        <div class="flex mt5">
          <p>订单编号：{{ detail.OrdersNo }}</p>
          <p class="ml20">
            购买账号：昵称（{{ detail.NickName || detail.Phone }}）
          </p>
        </div>
        <el-descriptions direction="vertical" :column="4" class="mytable">
          <el-descriptions-item
            label-class-name="my-label"
            content-class-name="my-content"
            label="商品名称"
            :span="2"
            >{{ detail.RelatedName }}</el-descriptions-item
          >
          <el-descriptions-item
            label-class-name="my-label"
            content-class-name="my-content"
            label="类型"
            >{{ detail.RelatedTypeTxt }}</el-descriptions-item
          >
          <el-descriptions-item
            label-class-name="my-label"
            content-class-name="my-content"
            label="价格"
          >
            <span class="Price">¥{{ detail.Price }}</span>
          </el-descriptions-item>
        </el-descriptions>
        <div class="mt20 payType">
          <div class="tab1 mb10">
            <div class="">支付方式</div>
          </div>

          <div class="flex">
            <div
              class="item"
              @click="payType = 1"
              :class="payType == 1 ? 'active' : ''"
            >
              <img src="@/assets/img/home/39.png" class="img1" alt="" />
              <span>支付宝</span>
            </div>
            <div
              class="item"
              @click="payType = 2"
              :class="payType == 2 ? 'active' : ''"
            >
              <img src="@/assets/img/home/38.png" class="img1" alt="" />
              <span>微信</span>
            </div>
          </div>
        </div>
        <div class="pay-box">
          <p>
            应付金额： <span class="Price">¥{{ detail.Price }}</span>
          </p>
          <p>
            实付金额： <span class="Price">¥{{ detail.Price }}</span>
          </p>
          <el-button type="primary" class="ml50 pay" @click="toPay"
            >立即支付</el-button
          >
        </div>
      </div>
    </div>
    <div class="showIframe" v-if="showIframe" @click="hideIframe">
      <iframe :src="iframeSrc" frameborder="0"></iframe>
    </div>
    <ercode-img
      :payCodeImg="payCodeImg"
      @closeFun="handleCodeImg"
      :show="codeImg"
    ></ercode-img>
    <div class="paying" v-if="payShow">
      <div class="paying-block">
        正在支付中...
        <p class="paynig-close" @click="closePaying">×</p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Orders_GetPayConfirm,
  AliPayPC,
  WxPayPC,
  CheckPayStatus,
} from "@/api/order";
import ercodeImg from "@/components/ercodeImg.vue";
export default {
  name: "",
  components: { ercodeImg },
  data() {
    return {
      detail: {},
      payType: 1,
      codeImg: false,
      payCodeImg: "", //支付二维码
      setTimer: null,
      loading: false,
      showIframe: false,
      iframeSrc: "",
      payShow: false,
    };
  },
  created() {
    const { OrdersID } = this.$route.query;
    Orders_GetPayConfirm({ OrdersID }).then((res) => {
      this.detail = res.data;
    });
  },

  computed: {},
  methods: {
    closePaying() {
      this.payShow = false;
      clearInterval(this.setTimer);
      this.setTimer = false;
    },
    hideIframe() {
      this.showIframe = false;
      clearInterval(this.setTimer);
      this.setTimer = null;
    },
    async toPay() {
      if (this.payType == 1) {
        //支付宝
        let data = {
          OrdersID: this.detail.OrdersID,
        };
        let res2 = await AliPayPC(data);
        this.payShow = true;

        // this.showIframe = true
        // this.iframeSrc = res2.data.PayUrl

        window.open(res2.data.PayUrl);
        // let num = 0
        clearInterval(this.setTimer);
        this.setTimer = null;
        this.setTimer = setInterval(async () => {
          let res3 = await CheckPayStatus(data).catch(() => {});
          if (res3.data.PayStatus == 1) {
            //已支付
            clearInterval(this.setTimer);
            this.setTimer = null;
            // this.showIframe = false
            // this.loading = false
            this.$message.success("支付成功");
            this.$router.replace({
              path: "/orderResult",
              query: {
                OrdersID: this.$route.query.OrdersID,
              },
            });
          }
        }, 3000);
        //跳转支付宝地址
      } else {
        //微信
        let data = {
          OrdersID: this.detail.OrdersID,
        };
        let res1 = await WxPayPC(data);

        this.codeImg = true;
        this.payCodeImg = res1.data.PayUrl;

        let num = 0;
        this.setTimer = setInterval(async () => {
          if (num > 15) {
            this.codeImg = false;
            clearInterval(this.setTimer);
            this.setTimer = null;
            this.$message.error("支付超时");
            this.inIt();
            return;
          }
          num = Number(num + 1);
          let res3 = await CheckPayStatus(data);
          if (res3.data.PayStatus == 1) {
            //已支付
            this.codeImg = false;
            this.$message.success("支付成功");
            setTimeout(() => {
              this.$router.replace({
                path: "/orderResult",
                query: {
                  OrdersID: this.$route.query.OrdersID,
                },
              });
            }, 1000);
            clearInterval(this.setTimer);
            this.setTimer = null;
          }
        }, 3000);
      }
    },

    handleCodeImg() {
      this.codeImg = false;
      clearInterval(this.setTimer);
      this.setTimer = null;
      // this.$message.info("取消支付");
      //跳转 ，或提示支付成功
    },
  },
};
</script>
<style lang="scss" scoped>
.order-top {
  h2 {
    font-size: 24px;
    color: #333333;
  }
  p {
    font-size: 18px;
    color: #666666;
  }
}
.mytable {
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e9ecf0;
}
::v-deep .my-label {
  padding: 5px 20px;
  height: 67px;
  line-height: 67px;
  font-weight: bold;
  background: #f6f8fc;
  font-size: 20px;
  color: #333333;
  &::after {
    display: none;
  }
}

::v-deep .my-content {
  padding: 5px 20px;
  height: 67px;
  line-height: 67px;
  font-size: 18px;
  background: none;
  color: #666666;
  .Price {
    font-weight: bold;
    font-size: 20px;
    color: #e12a14;
  }
}
.payType {
  .tab1 {
    font-size: 20px;
    color: #333333;
  }
  .flex {
    gap: 20px;
    .item {
      cursor: pointer;
      width: 240px;
      height: 52px;
      font-size: 18px;
      line-height: 52px;
      color: #666666;
      text-align: center;
      background: #eef2f6;
      border-radius: 8px;
      img {
        width: 26px;
        height: 26px;
        margin-right: 10px;
      }
      &:hover {
        color: #2979fb;
        background: #e1edff;
        border: 1px solid #1477ff;

        position: relative;
        &::after {
          content: "";
          position: absolute;
          right: -1px;
          bottom: -2px;
          width: 33px;
          height: 19px;
          border-radius: 10px 0px 6px 0px;
          background: url("../../assets/img/home/40.png") no-repeat center;
          background-size: 32px 18px;
        }
      }
    }
    .active {
      color: #2979fb;
      background: #e1edff;
      border: 1px solid #1477ff;

      position: relative;
      &::after {
        content: "";
        position: absolute;
        right: -1px;
        bottom: -2px;
        width: 33px;
        height: 19px;
        border-radius: 10px 0px 6px 0px;
        background: url("../../assets/img/home/40.png") no-repeat center;
        background-size: 32px 18px;
      }
    }
  }
}
.pay-box {
  text-align: right;
  font-size: 18px;
  color: #666666;
  .Price {
    font-weight: bold;
    font-size: 24px;
    color: #e12a14;
  }
  .pay {
    margin-top: 20px;
    width: 144px;
    height: 52px;
    font-size: 18px;
    background: #1d79ff;
    border-radius: 6px;
  }
}
.paying {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;

  .paying-block {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    width: 400px;
    height: 100px;
    padding: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;

    .paynig-close {
      position: absolute;
      top: 10px;
      right: 15px;
      font-size: 24px;
    }
  }
}
</style>
